import React, { useCallback, useRef } from 'react';
import { useMappedState } from 'redux-react-hook';
import _includes from 'lodash/includes';
import { useAutoFocus } from 'common/customHooks';
import { consultationSelector } from 'redux/selectors/consultation';
import { Postcode } from './postcode';
import { Plain } from './plain';

export function FreeTextShort({ isInvalid, isMounted, onClickNextQuestion, isGuidanceTextShownAboveQuestion }) {
  const mapState = useCallback(state => consultationSelector(state), []);
  const { question } = useMappedState(mapState);
  const inputRef = useRef();
  useAutoFocus(true, isMounted, inputRef);

  if (_includes(question.tags, 'UI_POSTCODE')) {
    return (
      <Postcode
        question={question}
        isMounted={isMounted}
        onClickNextQuestion={onClickNextQuestion}
        isGuidanceTextShownAboveQuestion={isGuidanceTextShownAboveQuestion}
      />
    );
  }
  return (
    <Plain isMounted={isMounted} isInvalid={isInvalid} onClickNextQuestion={onClickNextQuestion} />
  );
}
